import { createAsyncAction, errorResult, successResult } from "pullstate";
import { GlobalStore } from "./GlobalStore";
import * as Sentry from "@sentry/browser";
import { Amount } from "../../types/amount";
import { Chain } from "@rainbow-me/rainbowkit";
import { Hash } from "viem";
import { CoinData } from "../../config/coingecko/coinGeckoTokenList";
import { CHAINS } from "config/chains";

export type Balances = Array<Balance>;

export interface Balance {
  tokenAddress: Hash;
  balance: Amount;
}

export const loadCoinGeckoTokenList = createAsyncAction(
  async ({ chain }: { chain: Chain }) => {
    try {
      const data = (await import(
        `../../config/coingecko/${CHAINS[chain.id].coingeckoId}_data.json`
      )) as { default: Record<Hash, CoinData> };
      return successResult(data.default);
    } catch (error) {
      console.error(`Failed to load data for ${CHAINS[chain.id].coingeckoId}:`, error);
    }
    Sentry.captureException(`Could not get coingecko tokenlist`);
    console.error(`Could not get balances`);
    return errorResult([], `Couldn't get coingecko tokenlist`);
  },
  {
    postActionHook: ({ result }) => {
      if (!result.error) {
        GlobalStore.update(s => {
          s.coinGeckoTokenList = result.payload;
        });
      }
    },
  }
);
